import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import { RadioBilling, radioBillingSchema } from '@sophocles/entities/RadioBilling/radioBillingRecord';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';
import { fromJS } from 'immutable';
import { normalize } from 'normalizr';

/* Receive Actions */
export const RECEIVE_RADIO_BILLINGS = 'RECEIVE_RADIO_BILLINGS';
function receiveRadioBillings(json) {
  return {
    type: RECEIVE_RADIO_BILLINGS,
    radioBillings: mapListToRecords(json, RadioBilling),
  };
}

/* Request Actions */
// starter request
export const REQUEST_RADIO_BILLING = 'REQUEST_RADIO_BILLING';
function requestRadioBilling(radioBilling_id) {
  return {
    type: REQUEST_RADIO_BILLING,
    radioBilling_id,
  };
}

export const REQUEST_RADIO_BILLING_FOR_RADIO = 'REQUEST_RADIO_BILLING_FOR_RADIO';
function requestRadioBillingForRadio(radio_id) {
  return {
    type: REQUEST_RADIO_BILLING_FOR_RADIO,
    radio_id,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchRadioBilling(radioBilling_id) {
  return dispatch => {
    dispatch(requestRadioBilling(radioBilling_id));
    return apiClient
      .get(`/radiobilling/${radioBilling_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'radioBillings', radioBillingSchema))
      .then(json => dispatch(receiveRadioBillings(json.entities.radioBillings)))
      .catch(error => {
        dispatch(genericErrorAction(error, REQUEST_RADIO_BILLING));
      });
  };
}

export function fetchRadioBillingForRadio(radio_id) {
  return dispatch => {
    dispatch(requestRadioBillingForRadio(radio_id));
    return apiClient
      .get(`/radiobilling/?radio=${radio_id}`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data.results, 'radioBillings', radioBillingSchema))
      .then(json => dispatch(receiveRadioBillings(json.entities.radioBillings)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_RADIO_BILLING)));
  };
}

export function rawFetchRadioBillingForRadio(radio_id) {
  return dispatch => {
    dispatch(requestRadioBillingForRadio(radio_id));
    return apiClient
      .get('/radiobilling/', { params: { radio: radio_id } })
      .then(checkHttpStatus)
      .then(response => response.data)
      .then(rawJson => (rawJson.results.length > 0 ? fromJS(rawJson.results[0]) : fromJS({})))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_RADIO_BILLING)));
  };
}

/* Edit Actions */
export const EDIT_RADIO_BILLING = 'EDIT_RADIO_BILLING';
export function editRadioBilling(radioBilling_id) {
  return {
    type: EDIT_RADIO_BILLING,
    radioBilling: radioBilling_id,
  };
}

export function patchRadioBilling(radioBilling_id, values) {
  return dispatch => {
    dispatch(editRadioBilling(radioBilling_id));
    return apiClient
      .patch(`/radiobilling/${radioBilling_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, radioBillingSchema))
      .then(json => {
        dispatch(receiveRadioBillings(json.entities.radioBillings));
      })
      .catch(error => {
        dispatch(genericErrorAction(error, EDIT_RADIO_BILLING));
      });
  };
}

/* Create Actions */
export const CREATE_RADIO_BILLING = 'CREATE_RADIO_BILLING';
function sayCreateRadioBilling(values) {
  return {
    type: CREATE_RADIO_BILLING,
    values: values,
  };
}

export function createRadioBilling(values) {
  return dispatch => {
    dispatch(sayCreateRadioBilling(values));
    return apiClient
      .post(`/radiobilling/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, radioBillingSchema))
      .then(json => {
        dispatch(receiveRadioBillings(json.entities.radioBillings));
      })
      .catch(error => {
        dispatch(genericErrorAction(error, CREATE_RADIO_BILLING));
      });
  };
}

/* Delete Actions */
export const DELETE_RADIO_BILLING = 'DELETE_RADIO_BILLING';
function sayDeleteRadioBilling(radioBilling_id) {
  return {
    type: DELETE_RADIO_BILLING,
    radioBilling: radioBilling_id,
  };
}

export function deleteRadioBilling(radioBilling_id) {
  return dispatch =>
    apiClient
      .delete(`/radiobilling/${radioBilling_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteRadioBilling(radioBilling_id)))
      .catch(error => {
        dispatch(genericErrorAction(error, DELETE_RADIO_BILLING));
      });
}
